import React from 'react';

// Styles
import './SurfaceAITableHeaders.scss';

const SurfaceAITableHeaders = () => {
  const baseClassName = 'SurfaceAITableHeaders';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__logo`}></div>
      <div className={`${baseClassName}__name`}>Name</div>
      <div className={`${baseClassName}__insight`}>Insight</div>
      <div className={`${baseClassName}__status`}>Status</div>
      <div className={`${baseClassName}__avatars`}></div>
      <div className={`${baseClassName}__actions`} />
    </div>
  );
};

export default SurfaceAITableHeaders;
